import React from 'react';
import { DataBox, DataBoxBaseProps } from 'src/components/molecules/DataBox';
import { DataTable } from 'src/components/molecules/DataTable';
import { useMetricTableColumns } from '../../hooks/useMetricTableColumns';
import { useMetricsByCampaignGroup } from '../../hooks/useMetricsByCampaignGroup';

export const MetricsByCampaignGroupTable: React.FC<DataBoxBaseProps> = ({
  ...props
}) => {
  const { data, isError, isLoading } = useMetricsByCampaignGroup();
  const columns = useMetricTableColumns('Campaign Group');

  return (
    <DataBox
      {...props}
      exportEnabled
      hasData={data.length > 0}
      isError={isError}
      isLoading={isLoading}>
      <DataTable csvFileName="campaign-groups" data={data} columns={columns} />
    </DataBox>
  );
};
